import HOST from './host';

const SIGN = `${ HOST }/sign`;
const DEALS = `${ HOST }/deals`;
const SETTINGS = `${ HOST }/settings`;

const API = {

  sign: {

    in:    `${ SIGN }/in`,
    up:    `${ SIGN }/up`,
    check: `${ SIGN }/check`,

  },

  tariff: {

    pay: `${ HOST }/tariff/pay`,

  },

  settings: {

    update: `${ SETTINGS }/update`,
    changeCurrency: `${ SETTINGS }/changeCurrency`,
    changePriceWatchMode: `${ SETTINGS }/changePriceWatchMode`,
    changeCommissionOrTimeMode: `${ SETTINGS }/changeCommissionOrTimeMode`,

  },
  
  deals: {

    all:     `${ DEALS }/all`,
    add:     `${ DEALS }/add`,
    close:   `${ DEALS }/close`,
    remove:  `${ DEALS }/remove`,
    rename:  `${ DEALS }/rename`,
    comment: `${ DEALS }/comment`,
    movements: `${ DEALS }/movements`,
    setMaxAmount: `${ DEALS }/setMaxAmount`,

  },
  

}

export default API;